import { Component, OnInit, ViewChild } from '@angular/core';
import { GeneralService } from '../services/general.service';
import { AvtListesComponent } from '../avt-listes/avt-listes.component';
import { Router } from '@angular/router';
import { DateService } from '../services/date.service';
import { AvtDialogDeleteComponent } from '../avt-dialog-delete/avt-dialog-delete.component';
import { MatDialogConfig } from '@angular/material/dialog';
declare var $ : any
@Component({
  selector: 'app-avt-liste-evennement',
  templateUrl: './avt-liste-evennement.component.html',
  styleUrls: ['./avt-liste-evennement.component.scss']
})
export class AvtListeEvennementComponent implements OnInit 
{
  constructor(public router: Router,public generalService :GeneralService,public dateService :DateService) { }
  exist : boolean = true;
  dateEvenement = new Date();
  dateEvenementFin = new Date();
  columnsEvennement=
  {
    "TableRD":
    [
      {"TableRE_Code":"","TableRD_Champs":"Evenement_Titre","Lg_Code":"","TableRD_Des":"Titre","TableRD_Largeur":200,"TableRD_ReadOnly":true,"TableRD_Format":null,"TableRD_Alligement":0,"TableRD_Ordre":2,"TableRD_Type":0,"TableRD_Param1":null,"TableRD_Param2":null,"TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null,dataSelect:[],valueSelect:"DiverSys_Index",textSelect:"DiverSys_Titre"},
      {"TableRE_Code":"","TableRD_Champs":"Evenement_DateDebut","Lg_Code":"","TableRD_Des":"Date début","TableRD_Largeur":100,"TableRD_ReadOnly":true,"TableRD_Format":"dd-MM-yyyy","TableRD_Alligement":0,"TableRD_Ordre":4,"TableRD_Type":4,"TableRD_Param1":null,"TableRD_Param2":"number","TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null},
      {"TableRE_Code":"","TableRD_Champs":"Evenement_DateFin","Lg_Code":"","TableRD_Des":"Date fin","TableRD_Largeur":100,"TableRD_ReadOnly":true,"TableRD_Format":"dd-MM-yyyy","TableRD_Alligement":0,"TableRD_Ordre":5,"TableRD_Type":4,"TableRD_Param1":null,"TableRD_Param2":"number","TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null},
      {"TableRE_Code":"","TableRD_Champs":"Evenement_HeureDebut","Lg_Code":"","TableRD_Des":"H.Début","TableRD_Largeur":70,"TableRD_ReadOnly":true,"TableRD_Format":"h:mm","TableRD_Alligement":0,"TableRD_Ordre":5,"TableRD_Type":9,"TableRD_Param1":null,"TableRD_Param2":"number","TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null},
      {"TableRE_Code":"","TableRD_Champs":"Evenement_HeureFin","Lg_Code":"","TableRD_Des":"H.Fin","TableRD_Largeur":70,"TableRD_ReadOnly":true,"TableRD_Format":"h:mm","TableRD_Alligement":0,"TableRD_Ordre":5,"TableRD_Type":9,"TableRD_Param1":null,"TableRD_Param2":"number","TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null},
    ]
  }
  columnsDestination=
  {
    "TableRD":
    [
      {"TableRE_Code":"","TableRD_Champs":"TypeDestination_Code","Lg_Code":"","TableRD_Des":"Titre","TableRD_Largeur":200,"TableRD_ReadOnly":true,"TableRD_Format":null,"TableRD_Alligement":0,"TableRD_Ordre":2,"TableRD_Type":0,"TableRD_Param1":null,"TableRD_Param2":null,"TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null,dataSelect:[],valueSelect:"DiverSys_Index",textSelect:"DiverSys_Titre"},
    ]
  }
  columnsDeffision=
  {
    "TableRD":
    [
      {"TableRE_Code":"","TableRD_Champs":"typesDiffusion","Lg_Code":"","TableRD_Des":"Titre","TableRD_Largeur":200,"TableRD_ReadOnly":true,"TableRD_Format":null,"TableRD_Alligement":0,"TableRD_Ordre":2,"TableRD_Type":0,"TableRD_Param1":null,"TableRD_Param2":null,"TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null,dataSelect:[],valueSelect:"DiverSys_Index",textSelect:"DiverSys_Titre"},
    ]
  }
  @ViewChild("listeEvennementComponen",{static:false}) listeEvennementComponen : AvtListesComponent;
  @ViewChild("listeDeffisionComponen",{static:false}) listeDeffisionComponen : AvtListesComponent;
  @ViewChild("listeDestinationComponen",{static:false}) listeDestinationComponen : AvtListesComponent;
  typesPublique=this.generalService.typesPublique ;
  diffusions =this.generalService.diffusions;
  dsEvenement;
  showPositionEvennement : boolean = false;
  positionEvennement: string;
  listePositionEvennement =this.generalService.listePositionEvennement;
  ngOnInit() 
  {
    this.getListeEnenement();
  }
  getClass()
  {
    if(this.generalService.ajouterScroll)
    return "scroll-x"
    else
    return ""
  }
  getListeEnenement()
  {
    this.exist = false
    this.generalService.rechercheTable(this.generalService.url + "avtEvenementDF&param=" + this.dateService.setFormatDateRechercheServer(this.dateEvenement)+","+ this.dateService.setFormatDateRechercheServer(this.dateEvenementFin)).subscribe(data =>
    {
      this.exist = true;
      this.showPositionEvennement = false;
      this.listeEvennementComponen.deselectTable()
      this.listeEvennementComponen.setDataSource(data);
      this.listeDeffisionComponen.setDataSource([])
      this.listeDestinationComponen.setDataSource([])
      $("#hiddenBtnForActualiserListe").trigger("click");
    })
  }
  dateChange()
  {
    this.getListeEnenement()
  }
  // ajouter()
  // {
  //   this.generalService.param_code = "-1"
  //   this.generalService.typeTrs = "1";
  //   this.generalService.ajouterScroll = true;
  //   this.generalService.dialogOpend = this.generalService.dialog.open(AvtEvenementComponent, new MatDialogConfig());
  //   this.generalService.dialogOpend.afterClosed().subscribe(() =>
  //   {
  //     this.generalService.param_code = null;
  //   this.generalService.ajouterScroll = false;
  //   this.generalService.typeTrs = null;
  //   });
  // }
  showDetailEvenement(Evenement_Code)
  {
    this.generalService.rechercheTable("ds/formdata?code=avtEvenement&val="+ Evenement_Code).subscribe(data =>
    {
      this.dsEvenement = data;
      this.setListeTypePublique();
      this.setListeTypeDiffusion();
    })
  }
  setListeTypePublique()
  {
    this.listeDestinationComponen.setDataSource(this.dsEvenement.avtEvenementDest);
  }
  setListeTypeDiffusion()
  {
    this.dsEvenement.avtEvenementDiff.forEach(typesDiffusion => 
    {
      var findPosition = this.generalService.listePositionEvennement.find(pos =>{return pos.value == typesDiffusion.TypeDiffusion_Code})
      var findTypesDiffusion = this.diffusions.find(type =>{return type.value == typesDiffusion.TypeDiffusion_Code})
      if(typesDiffusion.TypeDiffusion_Code != "3")
      typesDiffusion["typesDiffusion"] = (findTypesDiffusion != undefined ? findTypesDiffusion.text :  (findPosition != undefined? (this.diffusions.find(dif =>{return dif.value.toString() == "3"}).text + " " +findPosition.text.toLowerCase()) : ""))
      // else
      //  typesDiffusion["typesDiffusion"] = (findTypesDiffusion != undefined ? findTypesDiffusion.text :  (findPosition != undefined? (this.diffusions.find(dif =>{return dif.value.toString() == "3"}).text + " " +findPosition.text.toLowerCase()) : ""))
    });
    this.dsEvenement.avtEvenementDiff = this.dsEvenement.avtEvenementDiff.filter(diff =>{return diff.TypeDiffusion_Code != "3"})
    this.listeDeffisionComponen.setDataSource(this.dsEvenement.avtEvenementDiff);



    
    // var evDif = this.dsEvenement.avtEvenementDiff.find(element => {return element.TypeDiffusion_Code == "3" });
    // if(evDif)
    // {
    //   this.showPositionEvennement = true;
    //   this.positionEvennement = evDif.TypeDiffusion_Code;
    // }
    // else
    //   this.showPositionEvennement = false;

  }
  clickBtnHeat(event)
  {
    switch (event.name)
    {
      case "selectRow":
      {
        this.showDetailEvenement(event.row.Evenement_Code)
        break;
      }
    }
  }
  modifier()
  {
    if(this.listeEvennementComponen.row)
    {
      var windows = this.generalService.popupCenter("/w/avt/evenement/"+this.listeEvennementComponen.row.Evenement_Code + "/2");
      windows.onbeforeunload = ()=>
      {
        this.getListeEnenement();
      }
    }
      // this.router.navigate(["avt/evenement",this.listeEvennementComponen.row.Evenement_Code,"2"]);
    else
      this.generalService.dialogSuccess("Veuillez sélectionner une seule ligne",false)
  }
  supprimer()
  {
    if(this.listeEvennementComponen.row)      
    {
      var dialogRef = this.generalService.dialog.open(AvtDialogDeleteComponent, new MatDialogConfig());
      dialogRef.afterClosed().subscribe(result =>
      {
        if(result == "supprimer")
        {
          var deleteFn = this.generalService.supprimerSanMsgConfirm(this.listeEvennementComponen.row.Evenement_Code,"avtEvenement");
          if(deleteFn != null)
          {
            this.exist = false;
            deleteFn.subscribe(data => 
            {
              this.getListeEnenement();
              this.exist = true
            })
          }
        }
      })
    }
    else
      this.generalService.dialogSuccess("Veuillez sélectionner une seule ligne",false)
  }
  //ne pas supprimer
  doNotThink()
  {
    console.log('doNotThink');
  }
}